// extracted by mini-css-extract-plugin
export var templateWrap = "c_c";
export var flex = "c_d";
export var title = "c_f";
export var article = "c_g";
export var aside = "c_h";
export var fileWrapper = "c_j";
export var featuredImage = "c_k";
export var belowWindow = "c_l";
export var observeWrap = "c_m";